import MobileTag from "./MobileTag";

export default MobileTag;
